import messages from './pokemon-tag-message.js';
export default [
    {tag: 'se', intlLabel: messages.se},
    {tag: 'BGM', intlLabel: messages.bgms}
];
